export default [
  {
    path: "/laws",
    name: "lawSearch",
    component: () =>
      import(/* webpackChunkName: "laws" */ "@/views/laws/Search.vue"),
    meta: {
      layout: "Split",
      showBack: true
    }
  },
  {
    path: "/laws/:id",
    name: "lawPage",
    component: () =>
      import(/* webpackChunkName: "laws" */ "@/views/laws/Law.vue"),
    meta: {
      layout: "Split",
      showBack: true,
      headerCollapsible: true
    }
  }
];
